import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ErrorFallback from "../../common/error-fallback";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        {/* Tell the prerender service to return a real 404 to crawlers */}
        <meta name="prerender-status-code" content="404" />
        <title>
          {t("error.notFound.pageTitle", "Page not found")} | Nicolas Smith Platform
        </title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ErrorFallback showAsNotFound showReload showHome />
    </>
  );
};

export default NotFoundPage;
